import API from "../util/api";

export const addBankAccount = async (payload) => {
  let data = null;

  await API.post('/add-bank-account', payload)
    .then(res => {
      data = res.data.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}

export const getUser = async (payload) => {
  let data = null;

  await API.get('/user', payload)
    .then(res => {
      data = res.data;
    })
    .catch((err) => {
      if(err.response.status === 401){
        return JSON.stringify({message:'unauthorized'})
      }
    });

  return data;
}